var map = {
	"./en-us.js": "TB9T",
	"./zh-cn.js": "8ngb",
	"./zh-tw.js": "4PAp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lcOH";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/config nonrecursive \.js$
// module id = lcOH
// module chunks = 1